import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const KEY = "hb_cart_v1";
const RV_KEY = "hb_recently_viewed";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [recentlyViewed, setRV] = useState(() => {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem(RV_KEY, JSON.stringify(recentlyViewed)); }, [recentlyViewed]);

  const addItem = useCallback((line) => {
    setItems(prev => {
      const key = `${line.product_id}-${line.color}-${line.size}`;
      const idx = prev.findIndex(i => `${i.product_id}-${i.color}-${i.size}` === key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + (line.qty || 1) };
        return copy;
      }
      return [...prev, { ...line, qty: line.qty || 1 }];
    });
  }, []);
  const updateQty = useCallback((key, qty) => {
    setItems(prev => prev.map(i =>
      `${i.product_id}-${i.color}-${i.size}` === key ? { ...i, qty: Math.max(1, qty) } : i
    ));
  }, []);
  const removeItem = useCallback((key) => {
    setItems(prev => prev.filter(i => `${i.product_id}-${i.color}-${i.size}` !== key));
  }, []);
  const clear = useCallback(() => setItems([]), []);

  const recordView = useCallback((product) => {
    setRV(prev => {
      const filtered = prev.filter(p => p.product_id !== product.product_id);
      return [product, ...filtered].slice(0, 8);
    });
  }, []);

  return (
    <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clear, recentlyViewed, recordView }}>
      {children}
    </CartCtx.Provider>
  );
}
